import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import ProfileContainer from '../../components/Profile/ProfileContainer';

const Profile = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <ProfileContainer />
        </WrapperSection>
    );
};

export default Profile;
